import { useTranslation } from 'react-i18next'

import { Header } from '../../../components/Header'
import GenerateboContainer from './generatebo/Generatebo.container'

const Trial: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Header title={t('trial.title')} />

      <GenerateboContainer />
    </>
  )
}

export default Trial
